import React, { lazy } from 'react';
import { BookOpen } from 'lucide-react';
interface MegaPackCompositeProps {
  size?: 'normal' | 'small';
}
const MAIN_IMG = 'https://cdn.magicpatterns.com/uploads/9QUoXoDgWgtaZQB1gJBejf/1_Cover_Principal_.png';
const BONUS_IMGS = ['https://cdn.magicpatterns.com/uploads/grSrCWvkYRmGTqRh3qdNLX/bono1.png', 'https://cdn.magicpatterns.com/uploads/tn1pDDJCEHEPMppFasdmLr/bono2.png', 'https://cdn.magicpatterns.com/uploads/dXqV1muJSjGaran9mJFchj/bono3.png', 'https://cdn.magicpatterns.com/uploads/wB9v6rrxXYqFBfNjDwVTS6/bono4.png'];
const BONUS_POSITIONS = [{
  rotate: '-12deg',
  translateX: '-55%',
  translateY: '4%',
  zIndex: 1
}, {
  rotate: '-6deg',
  translateX: '-28%',
  translateY: '-2%',
  zIndex: 2
}, {
  rotate: '6deg',
  translateX: '28%',
  translateY: '-2%',
  zIndex: 2
}, {
  rotate: '12deg',
  translateX: '55%',
  translateY: '4%',
  zIndex: 1
}];
export const MegaPackComposite: React.FC<MegaPackCompositeProps> = ({
  size = 'normal'
}) => {
  const isSmall = size === 'small';
  const mainWidth = isSmall ? 'w-40 md:w-52' : 'w-52 md:w-72';
  const bonusWidth = isSmall ? 'w-28 md:w-36' : 'w-36 md:w-48';
  const containerHeight = isSmall ? 'h-56 md:h-72' : 'h-72 md:h-96';
  return <div className={`relative ${containerHeight} w-full flex items-center justify-center`} data-id="element-85">
      {/* Bonuses behind */}
      {BONUS_IMGS.map((img, i) => <img key={i} src={img} alt={`Bono ${i + 1}`} loading="lazy" className={`absolute ${bonusWidth} drop-shadow-lg rounded-md`} style={{
      transform: `translateX(${BONUS_POSITIONS[i].translateX}) translateY(${BONUS_POSITIONS[i].translateY}) rotate(${BONUS_POSITIONS[i].rotate})`,
      zIndex: BONUS_POSITIONS[i].zIndex
    }} data-id="element-86" />)}

      {/* Main ebook in front */}
      <img src={MAIN_IMG} alt="MegaPack Ciencias Naturales - 5 Tomos" loading="lazy" className={`relative ${mainWidth} drop-shadow-2xl rounded-md`} style={{
      zIndex: 10
    }} data-id="element-87" />

      {/* 5 Tomos Badge */}
      <div className="absolute z-20 bg-orange-500 text-white px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5" style={{
      top: '0',
      right: isSmall ? '10%' : '5%',
      transform: 'rotate(12deg)'
    }} data-id="element-88">
        <BookOpen className="w-4 h-4" data-id="element-89" />
        <span className="font-bold text-xs" data-id="element-90">5 TOMOS</span>
      </div>

      {/* Shadow */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-3/4 h-6 bg-black/15 blur-xl rounded-full" style={{
      zIndex: 0
    }} data-id="element-91"></div>
    </div>;
};